import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { removeFromCart, updateQuantity } from '../features/cart/cartSlice'
import { useAuth } from '../context/AuthContext'

const CartComponent = () => {
    const [isCartOpen, setIsCartOpen] = useState(false)
    const dispatch = useDispatch()
    const { isAuthenticated } = useAuth()
    const navigate = useNavigate()

    const toggleCart = () => {
        setIsCartOpen(!isCartOpen)
    }

    // Updated Redux cartItems data path
    const cartItems = useSelector((state) => state.cart.items) || []

    const cartCount = cartItems.reduce((total, item) => total + (item.quantity || 1), 0)

    const handleRemoveItem = (itemId) => {
        dispatch(removeFromCart(itemId))
    }

    const handleQuantityChange = (itemId, newQuantity) => {
        if (newQuantity > 0) {
            dispatch(updateQuantity({ id: itemId, quantity: newQuantity }))
        } else {
            dispatch(removeFromCart(itemId))
        }
    }


    // Calculate total price considering quantities
    const totalPrice = cartItems.reduce((total, item) => {
        const price = parseFloat(item?.price) || 0;
        const quantity = item?.quantity || 1;
        return total + (price * quantity);
    }, 0);

    return (
        <div className={`as_cart ${isCartOpen ? 'cart_open' : ''}`}>
            <div className="as_cart_wrapper" onClick={toggleCart}>
                <span>
                    <img className='headerSvg' src="/assets/images/svg/cart.svg" alt="Cart" />
                    {cartCount > 0 && <span className="as_cartnumber">{cartCount}</span>}
                </span>
            </div>
            {isCartOpen && (
                <div className="as_cart_box">
                    {cartItems.length === 0 ? (
                        <div className="as_cart_empty">
                            <i className="fa fa-shopping-cart"></i>
                            <h4>Your cart is empty</h4>
                            <p>Add some items to get started!</p>
                        </div>
                    ) : (
                        <>
                            <div className="as_cart_list">
                                <ul>
                                    {cartItems.map((item) => (
                                        <li key={item?._id}>
                                            <div className="as_cart_img">
                                                <img
                                                    className="img-responsive"
                                                    src={item?.main_image ? `${process.env.REACT_APP_API_URL}/uploads/products/${item.main_image.url}` : item?.full_image}
                                                    alt={item?.title}
                                                />
                                            </div>
                                            <div className="as_cart_info">
                                                <a href="#" title={item?.title}>
                                                    {item?.title}
                                                </a>
                                                <p>
                                                    <strong>{item?.quantity || 1} × ₹{item?.price}</strong> = 
                                                    <span style={{ color: '#27ae60', fontWeight: '600', marginLeft: '5px' }}>
                                                        ₹{((item?.quantity || 1) * parseFloat(item?.price)).toFixed(2)}
                                                    </span>
                                                </p>
                                                <div className="quantity-controls">
                                                    <button 
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleQuantityChange(item?._id, (item?.quantity || 1) - 1);
                                                        }}
                                                        title="Decrease quantity"
                                                    >
                                                        −
                                                    </button>
                                                    <span>{item?.quantity || 1}</span>
                                                    <button 
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleQuantityChange(item?._id, (item?.quantity || 1) + 1);
                                                        }}
                                                        title="Increase quantity"
                                                    >
                                                        +
                                                    </button>
                                                    <i 
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleRemoveItem(item?._id);
                                                        }} 
                                                        className="fa fa-trash" 
                                                        title="Remove item"
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="as_cart_total">
                                <p>
                                    <strong>Total Amount</strong>
                                    <span>₹{totalPrice.toFixed(2)}</span>
                                </p>
                            </div>
                            <div className="as_cart_btn">
                                <button 
                                    className="as_btn" 
                                    type="button" 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if(!isAuthenticated){
                                            navigate('/login')
                                        } else {
                                            navigate('/checkout')
                                        }
                                        setIsCartOpen(false);
                                    }}
                                >
                                    <i className="fa fa-credit-card" style={{ marginRight: '8px' }}></i>
                                    Proceed to Checkout
                                </button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    )
}

export default CartComponent
